// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609180738/js/" + chunkId + "." + {"44":"280dd096","225":"63d7c394","481":"c7b18051","486":"99efca68","770":"4734371d"}[chunkId] + ".0.6375041984465538.chunk.js";
};